// import React, { useState, useRef, useEffect } from "react";
// import "./addropdown.css";
// import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function AddOptionDropdown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   setOptions,
//   customWidth,
//   customTop,
//   isRequired,
//   placeholder = "",
//   Height,
//   OverFlow,
//   minheight,
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [inputValue, setInputValue] = useState(""); // Handle user input
//   const [filteredOptions, setFilteredOptions] = useState(options); // For filtering options
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//         handleBlur(); // Save the input value when clicking outside
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   useEffect(() => {
//     // Filter options when the input value changes
//     if (inputValue.trim()) {
//       const filtered = options.filter((option) =>
//         option.label.toLowerCase().includes(inputValue.toLowerCase())
//       );
//       setFilteredOptions(filtered);
//     } else {
//       setFilteredOptions(options);
//     }
//   }, [inputValue, options]);

//   const handleAddOption = () => {
//     if (inputValue.trim() && !options.some((opt) => opt.label === inputValue)) {
//       const newOptionData = {
//         label: inputValue,
//         id: Date.now(), // Generate a unique ID
//       };
//       setOptions((prevOptions) => [...prevOptions, newOptionData]);
//       setSelected(inputValue); // Save the input value as selected
//       setInputValue(""); // Clear the input
//       setIsActive(false);
//     }
//   };

//   const handleBlur = () => {
//     if (inputValue.trim()) {
//       setSelected(inputValue); // Save the input value
//     }
//   };

//   return (
//     <div className="dropdown" style={{ width }} ref={dropdownRef}>
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
//         <input
//           type="text"
//           placeholder={placeholder || "Type or select an option"}
//           value={inputValue}
//           onChange={(e) => setInputValue(e.target.value)}
//           onBlur={handleBlur} // Save the value when the user clicks away
//           onClick={(e) => {
//             e.stopPropagation();
//             setIsActive(true);
//           }}
//         />
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             maxHeight: minheight,
//             height: Height,
//             overflow: OverFlow,
//           }}
//         >
//           {filteredOptions.length > 0 ? (
//             filteredOptions.map((option) => (
//               <div
//                 key={option.id}
//                 className="dropdown-item"
//                 onClick={() => {
//                   setSelected(option); // Save the selected value
//                   setInputValue(option.label); // Show the selected value in the input
//                   setIsActive(false);
//                 }}
//               >
//                 {option.label}
//               </div>
//             ))
//           ) : (
//             <div className="dropdown-item no-options">No options found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }








import React, { useState, useRef, useEffect } from "react";
import "./addropdown.css";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function AddOptionDropdown({
  width,
  label,
  selected,
  setSelected,
  options,
  setOptions,
  customWidth,
  customTop,
  isRequired,
  placeholder = "",
  Height,
  OverFlow,
  minheight,
  disabled 
}) {
  const [isActive, setIsActive] = useState(false);
  const [inputValue, setInputValue] = useState(""); // Handle user input
  const [filteredOptions, setFilteredOptions] = useState(options); // For filtering options
  const [error, setError] = useState(""); // Error message state
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
        handleBlur(); // Save the input value when clicking outside
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    // Filter options when the input value changes
    if (inputValue.trim()) {
      const filtered = options.filter((option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options);
    }
  }, [inputValue, options]);

  const handleAddOption = () => {
    if (inputValue.trim().length > 100) {
      setError("Set name cannot exceed 100 characters");
      return;
    }

    if (inputValue.trim() && !options.some((opt) => opt.label === inputValue)) {
      const newOptionData = {
        label: inputValue,
        id: Date.now(), // Generate a unique ID
      };
      setOptions((prevOptions) => [...prevOptions, newOptionData]);
      setSelected(inputValue); // Save the input value as selected
      setInputValue(""); // Clear the input
      setIsActive(false);
      setError(""); // Clear any previous error
    }
  };

  const handleBlur = () => {
    if (inputValue.trim().length > 50) {
      setError("Set name cannot exceed 50 characters");
      return;
    }

    if (inputValue.trim()) {
      setSelected(inputValue); // Save the input value
      setError(""); // Clear any previous error
    }
  };

  return (
    <div 
    className={`dropdown ${disabled ? "dropdown-disabled" : ""}`}     style={{ width }} ref={dropdownRef}>
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div className="dropdown-btn"
       onClick={() => setIsActive(!isActive)}>
        <input
          type="text"
          placeholder={placeholder || "Type or select an option"}
          value={inputValue}
          // onChange={(e) => {
          //   setInputValue(e.target.value);
          //   if (e.target.value.length <= 50) {
          //     setError(""); // Clear error when input is valid
          //   } else {
          //     setError("Set name cannot exceed 50 characters");
          //   }
          // }}
          onChange={(e) => {
            const value = e.target.value;

            if (value.length <= 105) { // Prevent typing after 55 characters
              setInputValue(value);

              if (value.length > 100) {
                setError("Set name cannot exceed 100 characters"); // Show error when exceeding 50 characters
              } else {
                setError(""); // Clear error when within valid range
              }
            }
          }}
          onBlur={handleBlur} // Save the value when the user clicks away
          onClick={(e) => {
            e.stopPropagation();
            setIsActive(true);
          }}
          disabled={disabled}
          style={disabled ? { } : {}}
        />
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {error && <div className="error-message">{error}</div>}
      {isActive && !disabled && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: minheight,
            height: Height,
            overflow: OverFlow,
          }}
        >
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.id}
                className="dropdown-item"
                onClick={() => {
                  setSelected(option); // Save the selected value
                  setInputValue(option.label); // Show the selected value in the input
                  setIsActive(false);
                  setError(""); // Clear error when an option is selected
                }}
              >
                {option.label}
              </div>
            ))
          ) : (
            <div className="dropdown-item no-options">No options found</div>
          )}
        </div>
      )}
    </div>
  );
}
